import React from 'react';
import Table from '../../../../common/Table';
import Alert from '../../../../common/informative/Alert';
import {
  maintenanceFailModeActivityInformationDefaultProps,
  maintenanceFailModeActivityInformationPropTypes,
} from '../proptypes/MaintenanceFailModePropTypes';
import { filterMethodCaseInsensitive } from '../../../../../utils/filter-methods';
import { DEFAULT_PAGE_SIZE } from '../../../../../config/constants';
import { MAINTENANCE_FAIL_MODE_ACTIVITY_COLUMNS } from '../../../../../config/columns';

const MaintenanceFailModeActivityBasicInformationResource = ({
  maintenanceFailModeActivityList,
}) => {
  const hasActivities = maintenanceFailModeActivityList.some(
    (item) => item.activity,
  );

  if (maintenanceFailModeActivityList.length === 0 || !hasActivities)
    return (
      <Alert
        type="warning"
        message="Modo de falla no tiene actividades asignadas."
      />
    );

  const data = maintenanceFailModeActivityList.map((item) => ({
    companyActivityId: item.activity
      ? item.activity.companyActivityId || '-'
      : '-',
    activityName: item.activity ? item.activity.name || '-' : '-',
  }));

  return (
    <Table
      columns={MAINTENANCE_FAIL_MODE_ACTIVITY_COLUMNS}
      data={data}
      filterable
      manual={false}
      defaultFilterMethod={filterMethodCaseInsensitive}
      defaultPageSize={
        maintenanceFailModeActivityList.length > 10
          ? DEFAULT_PAGE_SIZE
          : maintenanceFailModeActivityList.length
      }
      showPagination={maintenanceFailModeActivityList.length > 10}
    />
  );
};

MaintenanceFailModeActivityBasicInformationResource.propTypes =
  maintenanceFailModeActivityInformationPropTypes;

MaintenanceFailModeActivityBasicInformationResource.defaultProps =
  maintenanceFailModeActivityInformationDefaultProps;

export default MaintenanceFailModeActivityBasicInformationResource;
